import { CompanyUser } from "@/schema/CompanyUser";
import { atom, useAtomValue, useSetAtom } from "jotai";

type DialogAtom = {
  member?: CompanyUser;
  type: "" | "add" | "delete" | "edit" | "reset-password";
};

const dialogAtom = atom<DialogAtom>({
  member: undefined,
  type: "",
});

const memberAtom = atom((get) => get(dialogAtom).member);
const typeAtom = atom((get) => get(dialogAtom).type);

function useMemberDialog() {
  const setDialog = useSetAtom(dialogAtom);
  const member = useAtomValue(memberAtom);
  const type = useAtomValue(typeAtom);
  const resetDialog = () => setDialog({ member: undefined, type: "" });

  return {
    type,
    member,
    setDialog,
    resetDialog,
  };
}

export default useMemberDialog;
